import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Icon, Tooltip } from "@material-ui/core";
import {
  INTRUCTIONS,
  useAccessesStore,
} from "../../../../core/stores/AccessesStore";
import { useTranslation } from "react-i18next";

const DEFAULT_BTN_SIZE = 25;

const commonIcon = {
  width: "auto",
  height: "auto",
  padding: 1,
  fontSize: "95%",
};

const useStyles = makeStyles((theme) => ({
  controlsContainer: {
    display: "flex",
    position: "absolute",
    top: (DEFAULT_BTN_SIZE + 2) * -1,
    right: 0,
    gap: 5,
  },
  posBtn: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: DEFAULT_BTN_SIZE,
    height: DEFAULT_BTN_SIZE,
    border: "none",
    backgroundColor: `${theme.palette.content.mainColor}AA`,
    color: "#FFF",
    borderRadius: 3,
    "&:hover": {
      cursor: "pointer",
      transform: "scale(1.05)",
    },
    "&:disabled": {
      cursor: "not-allowed",
      backgroundColor: `grey`,
    },
  },
}));

export default function BandPositionalControls(props) {
  const { t } = useTranslation();
  const { ds, hidden, sectionIndex, sectionsLength } = props;
  const classes = useStyles();

  const { orderDS, changeHiddenOfSection, deleteBand } = useAccessesStore(
    (state) => ({
      orderDS: state.orderDS,
      changeHiddenOfSection: state.changeHiddenOfSection,
      deleteBand: state.deleteBand,
    })
  );

  const handleOrderDS = ({ ds, instruction }) => {
    orderDS({ ds, instruction });
  };

  return (
    <div className={classes.controlsContainer}>
      <Tooltip
        title={
          sectionIndex === sectionsLength - 1
            ? ""
            : t("CUSTOM_HOME_PSC_ALLDOWN")
        }
        disableHoverListener={sectionIndex === sectionsLength - 1}
      >
        <button
          onClick={() =>
            handleOrderDS({ ds, instruction: INTRUCTIONS.ALLDOWN })
          }
          className={classes.posBtn}
          disabled={sectionIndex === sectionsLength - 1}
        >
          <Icon className="fas fa-angle-double-down" style={commonIcon} />
        </button>
      </Tooltip>
      <Tooltip
        title={
          sectionIndex === sectionsLength - 1 ? "" : t("CUSTOM_HOME_PSC_DOWN")
        }
        disableHoverListener={sectionIndex === sectionsLength - 1}
      >
        <button
          onClick={() => handleOrderDS({ ds, instruction: INTRUCTIONS.DOWN })}
          className={classes.posBtn}
          disabled={sectionIndex === sectionsLength - 1}
        >
          <Icon className="fas fa-angle-down" style={commonIcon} />
        </button>
      </Tooltip>
      <Tooltip
        title={sectionIndex === 0 ? "" : t("CUSTOM_HOME_PSC_UP")}
        disableHoverListener={sectionIndex === 0}
      >
        <button
          onClick={() => handleOrderDS({ ds, instruction: INTRUCTIONS.UP })}
          className={classes.posBtn}
          disabled={sectionIndex === 0}
        >
          <Icon className="fas fa-angle-up" style={commonIcon} />
        </button>
      </Tooltip>
      <Tooltip
        title={sectionIndex === 0 ? "" : t("CUSTOM_HOME_PSC_ALLUP")}
        disableHoverListener={sectionIndex === 0}
      >
        <button
          onClick={() => handleOrderDS({ ds, instruction: INTRUCTIONS.ALLUP })}
          className={classes.posBtn}
          disabled={sectionIndex === 0}
        >
          <Icon className="fas fa-angle-double-up" style={commonIcon} />
        </button>
      </Tooltip>
      <Tooltip
        title={hidden ? t("CUSTOM_HOME_SHOW_BAND") : t("CUSTOM_HOME_HIDE_BAND")}
      >
        <button
          onClick={() =>
            changeHiddenOfSection({ newHidden: !hidden, sectionIndex })
          }
          className={classes.posBtn}
        >
          <Icon
            className={hidden ? "fas fa-eye" : "fas fa-eye-slash"}
            style={commonIcon}
          />
        </button>
      </Tooltip>
      <Tooltip title={t("CUSTOM_HOME_CARD_OPTIONS_DELETE")}>
        <button
          onClick={() => deleteBand({ sectionIndex })}
          className={classes.posBtn}
        >
          <Icon className="fas fa-trash" style={commonIcon} />
        </button>
      </Tooltip>
    </div>
  );
}
